import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "csc-header__left" }
const _hoisted_2 = { class: "csc-header__right" }
const _hoisted_3 = { class: "csc-body" }
const _hoisted_4 = { class: "csc-step__content" }

import { ref, computed, watch, onBeforeUnmount } from "vue";
import { Icon } from "@iconify/vue";
import type { CallScriptStep } from "@/types/outreach-cue-cards";

interface Props {
  callSteps: CallScriptStep[];
  visible: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DraggableCallScript',
  props: {
    callSteps: {},
    visible: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const containerRef = ref<HTMLElement | null>(null);
const isDragging = ref(false);
const posX = ref(0);
const posY = ref(0);
const hasBeenPositioned = ref(false);
const dragOffsetX = ref(0);
const dragOffsetY = ref(0);

const copyLabel = ref("Copy All");
let copyTimeout: ReturnType<typeof setTimeout> | null = null;

const copyIcon = computed(() => (copyLabel.value === "Copied!" ? "mdi:check" : "mdi:content-copy"));

const panelStyle = computed(() => {
  if (!hasBeenPositioned.value) return {};
  return {
    left: `${posX.value}px`,
    top: `${posY.value}px`,
    transform: "none",
  };
});

// Reset position each time the panel opens
watch(
  () => props.visible,
  (val) => {
    if (val) {
      hasBeenPositioned.value = false;
    }
  }
);

function startDrag(event: MouseEvent) {
  if ((event.target as HTMLElement).closest(".csc-header__btn")) return;

  isDragging.value = true;

  const el = containerRef.value;
  if (el) {
    const rect = el.getBoundingClientRect();
    if (!hasBeenPositioned.value) {
      posX.value = rect.left;
      posY.value = rect.top;
      hasBeenPositioned.value = true;
    }
    dragOffsetX.value = event.clientX - posX.value;
    dragOffsetY.value = event.clientY - posY.value;
  }

  document.addEventListener("mousemove", onDrag);
  document.addEventListener("mouseup", stopDrag);
  event.preventDefault();
}

function onDrag(event: MouseEvent) {
  if (!isDragging.value) return;
  posX.value = Math.max(0, Math.min(event.clientX - dragOffsetX.value, window.innerWidth - 420));
  posY.value = Math.max(0, Math.min(event.clientY - dragOffsetY.value, window.innerHeight - 100));
}

function stopDrag() {
  isDragging.value = false;
  document.removeEventListener("mousemove", onDrag);
  document.removeEventListener("mouseup", stopDrag);
}

async function handleCopyAll() {
  const text = props.callSteps.map((s) => `[${s.label}]\n${s.content}`).join("\n\n");
  try {
    await navigator.clipboard.writeText(text);
    copyLabel.value = "Copied!";
    if (copyTimeout) clearTimeout(copyTimeout);
    copyTimeout = setTimeout(() => {
      copyLabel.value = "Copy All";
    }, 2000);
  } catch {
    copyLabel.value = "Failed";
    if (copyTimeout) clearTimeout(copyTimeout);
    copyTimeout = setTimeout(() => {
      copyLabel.value = "Copy All";
    }, 2000);
  }
}

onBeforeUnmount(() => {
  document.removeEventListener("mousemove", onDrag);
  document.removeEventListener("mouseup", stopDrag);
  if (copyTimeout) clearTimeout(copyTimeout);
});

return (_ctx: any,_cache: any) => {
  return (__props.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "containerRef",
        ref: containerRef,
        class: _normalizeClass(["csc-panel", { 'csc-panel--dragging': isDragging.value }]),
        style: _normalizeStyle(panelStyle.value)
      }, [
        _createElementVNode("div", {
          class: "csc-header",
          onMousedown: startDrag
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(Icon), {
              icon: "mdi:phone-outline",
              width: "18",
              height: "18"
            }),
            _cache[1] || (_cache[1] = _createElementVNode("span", null, "Call Script", -1))
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              type: "button",
              class: "csc-header__btn",
              title: "Copy all",
              onClick: _withModifiers(handleCopyAll, ["stop"])
            }, [
              _createVNode(_unref(Icon), {
                icon: copyIcon.value,
                width: "16",
                height: "16"
              }, null, 8, ["icon"])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "csc-header__btn csc-header__btn--close",
              title: "Close",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('close')), ["stop"]))
            }, [
              _createVNode(_unref(Icon), {
                icon: "mdi:close",
                width: "18",
                height: "18"
              })
            ])
          ])
        ], 32),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.callSteps, (step, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx,
              class: "csc-step",
              style: _normalizeStyle({ borderLeftColor: step.color })
            }, [
              _createElementVNode("span", {
                class: "csc-step__label",
                style: _normalizeStyle({ color: step.color })
              }, _toDisplayString(step.label), 5),
              _createElementVNode("p", _hoisted_4, _toDisplayString(step.content), 1)
            ], 4))
          }), 128))
        ])
      ], 6))
    : _createCommentVNode("", true)
}
}

})